import { Enrollment } from '@rd/types';
import { toObject } from '@rd/utils/array.utils';
import {
  EnrollmentActions,
  EnrollmentActionTypes,
} from '../actions/enrollment.actions';

export interface EnrollmentState {
  enrollments: {
    [key: string]: Enrollment;
  };
  error: boolean;
  loading: boolean;
  success: boolean;
}

const initialState: EnrollmentState = {
  enrollments: {},
  error: false,
  loading: false,
  success: false,
};

export function enrollmentReducer(
  state: EnrollmentState = initialState,
  action: EnrollmentActions,
): EnrollmentState {
  switch (action.type) {
    case EnrollmentActionTypes.LOAD_ENROLLMENTS:
      return {
        ...state,
        enrollments: {},
        error: false,
        success: false,
        loading: true,
      };

    case EnrollmentActionTypes.LOAD_ENROLLMENTS_SUCCESS:
      return {
        ...state,
        enrollments: toObject(action.payload, 'id'),
        error: false,
        loading: false,
        success: true,
      };

    case EnrollmentActionTypes.LOAD_ENROLLMENTS_FAIL:
      return {
        ...state,
        enrollments: {},
        error: true,
        loading: false,
        success: false,
      };
  }

  return state;
}
